/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierClaimNoticeState {
  Needed = "needed",
  Sent = "sent",
}

export function instanceOfCarrierClaimNoticeState(value: any): boolean {
  for (const key in CarrierClaimNoticeState) {
    if (Object.prototype.hasOwnProperty.call(CarrierClaimNoticeState, key)) {
      if (
        CarrierClaimNoticeState[key as keyof typeof CarrierClaimNoticeState] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierClaimNoticeStateFromJSON(
  json: any,
): CarrierClaimNoticeState {
  return CarrierClaimNoticeStateFromJSONTyped(json, false);
}

export function CarrierClaimNoticeStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierClaimNoticeState {
  return json as CarrierClaimNoticeState;
}

export function CarrierClaimNoticeStateToJSON(
  value?: CarrierClaimNoticeState | null,
): any {
  return value as any;
}

export function CarrierClaimNoticeStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierClaimNoticeState {
  return value as CarrierClaimNoticeState;
}
